import { inject, type InjectionKey } from "vue";
import assertIsDefined from "./assertIsDefined";

export default function injectAsserted<T>(key: InjectionKey<T>): T {
  const injectedValue = inject(key);
  assertIsDefined(injectedValue, `InjectionKey ${key.toString()} was empty`);
  return injectedValue;
}
